/* eslint-disable react/jsx-props-no-spreading */
import { forwardRef, useEffect, useState } from 'react';
import { FaCheck } from 'react-icons/fa';

import c from '../utils/c';
import { groupButtonFocusStyles } from '../utils/constants/buttonFocusStyles';

export const CheckBox = forwardRef(
  (
    {
      checked: givenChecked,
      className = '',
      classNameLabel = '',
      defaultChecked = false,
      disabled = false,
      label = '',
      onChange = () => {},
      ...props
    },
    ref,
  ) => {
    const [checked, setChecked] = useState(defaultChecked);
    const labelId = label?.replaceAll(' ', '_');

    useEffect(() => {
      setChecked(givenChecked);
    }, [givenChecked]);

    return (
      <button
        className="flex items-center group"
        disabled={disabled}
        onClick={() => {
          // prevent race conditions
          const newValue = !checked;

          setChecked(newValue);
          onChange(newValue);
        }}
        type="button"
        {...props}
      >
        <span
          ref={ref}
          aria-checked={checked}
          aria-labelledby={label && labelId}
          className={c(
            className,
            'w-4 h-4 rounded cursor-pointer transition duration-200 border border-gray-400 group-hover:outline',
            'group-hover:outline-offset-2 group-hover:outline-2 group-hover:outline-accent-600',
            groupButtonFocusStyles,
            checked && 'bg-accent-600 border-accent-600',
            !checked && 'bg-white',
            disabled ? 'bg-gray-300 cursor-not-allowed' : 'cursor-pointer',
          )}
          role="checkbox"
        >
          <FaCheck
            className={c(
              'text-white stroke-current w-full h-full m-auto transform transition duration-200',
              !checked && 'scale-0',
              checked && 'scale-75',
            )}
          />
        </span>
        {label && (
          <span
            className={c(
              classNameLabel,
              'ml-2',
              disabled ? 'text-gray-500 cursor-not-allowed' : 'cursor-pointer',
            )}
            id={labelId}
          >
            {label}
          </span>
        )}
      </button>
    );
  },
);
